module.exports = __webpack_public_path__ + "media/images/weather/205_day-31b7bcf1958322cdedcd4187a3c13de2.png";